import { ExtraOptions, RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { PageContainerComponent } from './ft-pages/page-container/page-container.component';
import { PagesModule } from './ft-pages/pages.module';
import { RoutingGuardService } from '@services/routing-guard.service';

// Modules

// Components

// Services

const routes: Routes = [
  {
    path: '**',
    component: PageContainerComponent,
    canDeactivate: [RoutingGuardService],
  },
];
const routeOptions: ExtraOptions = {
  anchorScrolling: 'enabled', // NB: need this in Core project to scoll to product detail sections
  // enableTracing: true,
  scrollOffset: [0, 85], // hard-coded for now to allow for sticky nav height. TODO: put offset in <section-nav> css or use function
  scrollPositionRestoration: 'top', // TODO: Decide what works best when clocking Back button
  relativeLinkResolution: 'legacy',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routeOptions), PagesModule],
  exports: [RouterModule],
})
export class AppRoutingModule {}
